import { render, staticRenderFns } from "./SearchDataWasteCategoryModal.vue?vue&type=template&id=4d13d63c&scoped=true&"
import script from "./SearchDataWasteCategoryModal.vue?vue&type=script&lang=js&"
export * from "./SearchDataWasteCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./SearchDataWasteCategoryModal.vue?vue&type=style&index=0&id=4d13d63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d13d63c",
  null
  
)

export default component.exports